<template>
  <b-container id="body-container" style="padding: 0px" fluid>
    <b-row class="justify-content-center mb-5">
      <b-col cols="10">


          <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="10" md="8">
            <span>
              <h4 class="text-blackish title-body">Prove Buying Capability</h4>
            </span>
          </b-col>
          <b-col cols="2" md="3">
            <div class="color-design"></div>
          </b-col>
        </b-row>

        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="10" md="8">
            <h5>Funded companies are vetted by investors who expect timely ROI.  </h5>
            <h5>They will take immediate action to convert their funding into growth & revenue. </h5>
          </b-col>
        </b-row>


         <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="10" md="8">
            <span>
              <h4 class="text-blackish title-body">Prove Immediate Need</h4>
            </span>
          </b-col>
          <b-col cols="2" md="3">
            <div class="color-design"></div>
          </b-col>
        </b-row>

        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="10" md="8">
            <span>
              <h5>Rapid expansion causes growing pains, new teams, and new communication styles. </h5>
              <h5>Leaders become distanced from their teams requiring new leadership styles and tools.</h5>
            </span>
          </b-col>
        </b-row>

        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="10" md="8">
            <span>
              <h4 class="text-blackish title-body">Spark Conversations</h4>
            </span>
          </b-col>
          <b-col cols="2" md="3">
            <div class="color-design"></div>
          </b-col>
        </b-row>

        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="10" md="8">
            <span>
              <h5>Celebrates your prospects' funding round. The first hundred+ employees will be incredibly proud of their company's accomplishment.</h5>
              <h5>Emphasize your ability to continue their growth trajectory</h5>
            </span>
          </b-col>
        </b-row>




        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="10" md="8">
            <span>
              <h4 class="text-blackish title-body">Welcome new employees</h4>
            </span>
          </b-col>
          <b-col cols="2" md="3">
            <div class="color-design"></div>
          </b-col>
        </b-row>

        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="10" md="8">
            <h5>Funding leads to New rapid hiring = the best time to reach out. </h5>
            <h5>New hires are eager to make an impact & prove themselves. </h5>
            <h5>They will take action.</h5>
          </b-col>
        </b-row>
      </b-col>
    </b-row>


    <b-row id="launch-today-container" class="justify-content-center live-now">
      <b-col md="10">
        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="12" md="12">
            <span>
              <h2 class="text-blackish cta-title" style="text-align:center; color:white"><span style="color:deepskyblue">Recently funded</span> companies have <span style="color:deepskyblue">buying capability</span> and a set <span style="color:deepskyblue">timeline</span> for <span style="color:deepskyblue">rapid growth</span></h2>
            </span>
          </b-col>
        </b-row>

        <b-row class="">
        <b-col md="12" cols="12" class="buttons-close" >
          <span
            class="d-flex justify-content-center"
          >
            <b-button
                class="free-trial-button"
                @click.prevent="scrollFix('#filters')"
              >Request Demo</b-button>
          </span>

          <!--
          <a
            href="https://www.launchgravity.com/masters-of-marketing/#upcoming"
          >
            <b-button class="button-white-transparen"><b>Check our events</b></b-button>
          </a>
          -->
        </b-col>
      </b-row>
      </b-col>
    </b-row>

   <b-row class="justify-content-center mb-5">
    <b-col cols="12" id="filters">

      <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="12" md="12">
            <div class=" mx-auto">
              <div class="calendly-inline-widget" data-url="https://calendly.com/rosse/track-funded-accounts?text_color=193b56&primary_color=1765d8"></div>
            </div>
          </b-col>
        </b-row>
    </b-col>
   </b-row>

  </b-container>
</template>

<style scoped lang="sass">
@import @/sass/screens/masters-of-marketing/body.sass
@import @/sass/_components/main-card.sass
@import @/sass/screens/home/header.sass

</style>

<script>
// components
// import MainCard from '@/components/mainCardHome'
// import ourFleet from '@/components/ourFleetCard'
// import ourFleetOG from '@/components/ourFleetCardOriginal'
// import HostCard from '@/components/hostCard'
import VueScrollTo from 'vue-scrollto';

// data
// import { guests, yourHosts } from '@/data/masters-of-marketing.js'

export default {
  name: 'Body',
  components: {
    //MainCard,
    // ourFleet,
    //ourFleetOG,
    // HostCard
  },
  data: function() {
    return {
      timer: null,
      currentDate: null,

    }
  },
  computed: {
  },
  mounted() {
    let externalScript = document.createElement('script')
    externalScript.setAttribute('src', 'https://assets.calendly.com/assets/external/widget.js')
    document.head.appendChild(externalScript)
  },
  created() {
  },
  methods: {
    scrollFix: function(hash) {
      console.log('Scroll To')
      VueScrollTo.scrollTo(hash, 3000)
    },

  },
}
</script>
